import {
    Component,
    Directive,
    Input,
    TemplateRef,
    ViewContainerRef,
    ChangeDetectionStrategy,
} from '@angular/core';

@Directive({
    selector: '[appWaitUntilLoaded]',
    standalone: false,
})
export class WaitUntilLoadedDirective {
    @Input() public set appWaitUntilLoaded(data: any) {
        if (data) {
            this.viewContainerRef.clear();
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
        if (!data) {
            this.viewContainerRef.clear();
            this.viewContainerRef.createComponent(
                WaitUntilLoadedLoadingComponent
            );
        }
    }

    public constructor(
        private templateRef: TemplateRef<any>,
        private viewContainerRef: ViewContainerRef
    ) {}
}

@Component({
    selector: 'app-wait-until-loaded-loading',
    template: ` <app-loading></app-loading> `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class WaitUntilLoadedLoadingComponent {}
